import config from '../../config';

export default (story: any) =>
  story.map((storyNode: any) => {
    if (storyNode.type === 'image') {
      const imageSrc = storyNode.src;
      if (new RegExp(/(jpg|png|gif|svg)$/).test(imageSrc)) {
        return { ...storyNode, src: `${config.imageAPIBaseURL}/${imageSrc}` };
      }
    }
    return storyNode;
  });
